import { Link } from 'react-router-dom';
import logo from '../../images/logo/adamfritzlerlaw-logo.png';
import './style.scss';
const footerLinks = [
  {
    title: 'Contact Us',
    menus: [
      { name: 'Adam Fritzler' },
      { name: '2620 Mary Hill Road,' },
      { name: 'Port Coquitlam, BC' },
      { name: 'Phone: 604.927.2156' },
      { name: 'Fax: 604.927.2155' },
      { name: 'Email: adam@fritzlerlaw.ca' },
    ],
  },
  {
    title: 'Quick Links',
    menus: [
      { name: 'Home', route: '/' },
      { name: 'About Us', route: '/aboutus' },
      { name: 'Contact Us', route: '/contact' },
    ],
  },
];

const FooterArea = () => {
  return (
    <footer className='footerArea'>
      <div className='footerTopArea'>
        <div className='container'>
          <div className='row'>
            {footerLinks.map((menu, i) => (
              <div key={i} className='col-lg-4 col-md-6 col-sm-6'>
                <div className='footerWrap'>
                  <h3>{menu.title}</h3>
                  <ul>
                    {menu.menus.map((item, i) => (
                      <li key={i}>
                        {item.route ? (
                          <Link to={`${item.route}`}>{item.name}</Link>
                        ) : (
                          `${item.name}`
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
            <div className='col-lg-4 col-md-6 col-sm-6'>
              <div className='footerLogo'>
                <Link to='/'>
                  <img src={logo} alt='Fritzler Law Logo' />
                </Link>
                <p>
                  If you have legal issues or need for legal advice, we’re
                  available to chat. Be they family related, real estate
                  related, or criminal related, Adam Fritzler can assist.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='footerBottomArea'>
        <div className='container'>
          <div className='footerBottomContent'>
            <div className='row'>
              <div className='col-md-8 col-sm-10 col-12'>
                <span>
                  Privacy Policy | © 2025 Fritzler Law Professional Corporation.
                  All rights reserved
                </span>
              </div>
              {/* <div className='col-md-4 col-sm-2 col-12'>
                <ul className='socialListFooter'>
                  <li>
                    <a href='#'>
                      <i className='fa fa-facebook' aria-hidden='true'></i>
                    </a>
                  </li>
                  <li>
                    <a href='#'>
                      <i className='fa fa-twitter' aria-hidden='true'></i>
                    </a>
                  </li>
                  <li>
                    <a href='#'>
                      <i className='fa fa-linkedin' aria-hidden='true'></i>
                    </a>
                  </li>
                </ul>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default FooterArea;
